/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Carriage_LabelInputs */



/**
* | output |
* | --- |
* | "MOV/MP4 carriage" |
*
* @param {Embed_Captions_Local_Carriage_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_carriage_label = /** @type {((inputs?: Embed_Captions_Local_Carriage_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Carriage_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transporteur MOV/MP4")
	if (locale === "de") return /** @type {LocalizedString} */ ("MOV/MP4-Transport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Supporto per file MOV/MP4")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перенос MOV/MP4")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transporte MOV/MP4")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("MOV/MP4 载体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MOV/MP4ファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("MOV/MP4 कैरिज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato MOV/MP4")
	return /** @type {LocalizedString} */ ("MOV/MP4 carriage")
});